import { render, staticRenderFns } from "./upRightB.vue?vue&type=template&id=0d479bf1&scoped=true&"
import script from "./upRightB.vue?vue&type=script&lang=js&"
export * from "./upRightB.vue?vue&type=script&lang=js&"
import style0 from "./upRightB.vue?vue&type=style&index=0&id=0d479bf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d479bf1",
  null
  
)

export default component.exports